import React from "react";
import { observer } from "mobx-react";
import { useCommunitiesStore } from "communities/communities-listing/communities-page-context";
import CommunityCard from "communities/community-page/_components/card/community-card";

export const CommunitiesViewListItems = observer(() => {
    const communitiesStore = useCommunitiesStore();
    const listStore = communitiesStore.getListStore("communities");

    return (
        <>
            {listStore.paginatedItems.map((community) => {
                if (!community) return null;
                return (
                    <CommunityCard
                        key={community._id}
                        community={community}
                        onMouseEnter={() => {
                            communitiesStore.setMapCommunitySelected(community?._id);
                        }}
                        onMouseLeave={() => {
                            communitiesStore.setMapCommunitySelected.cancel();
                            communitiesStore.setMapCommunitySelected(undefined);
                        }}
                    />
                );
            })}
        </>
    );
});
